module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-761b72b1c2d348303df23096d4f2d45d.png";